import { Button } from '@mui/material'
import { FileResource } from '../../item/model/FileResource'
import './FileViewer.scss'
import { BodySmall } from '../../genericComponents/typographie/UIKitV2/BodySmall'
import FileSaver from 'file-saver'

export const UnsupportedViewer = (
{
    file,
    onClose
}:{
    file: FileResource,
    onClose?: () => void
}) => {

    const handleFileDownload = () => {
        FileSaver.saveAs(file.uri || '', file.name || 'downloaded_file')
    }

    return (
        <div className="unsupported-viewer">
            <BodySmall className="unsupported-file-text">File type not supported for preview. Please download file to view.</BodySmall>
            <div className="unsupported-file-actions">
                <Button variant="text" className="cancel-button" type="button" onClick={onClose}>Cancel</Button>
                <Button variant="contained" data-testid="download-file-no-preview" onClick={handleFileDownload} type="button">Download</Button>
            </div>
        </div>
    )
}